import React, { createContext, useContext, useState } from "react";

// Define translations
const translations = {
    en: {
        selectLanguage: "Select Language",
        country: "Country",
        mobileNumber: "Mobile Number",
        submit: "Submit",
        mobileRequired: "Mobile number is required",
        invalidMobile: "Invalid mobile number",
        developerInfo: "My name is Kamran Khan, and I am a full-stack developer with over 5 years of experience."
    },
    mr: {
        selectLanguage: "भाषा निवडा",
        country: "देश",
        mobileNumber: "मोबाईल नंबर",
        submit: "सबमिट",
        mobileRequired: "मोबाईल नंबर आवश्यक आहे",
        invalidMobile: "अवैध मोबाईल नंबर",
        developerInfo: "माझे नाव कमरान खान आहे, आणि मी ५ वर्षांचा अनुभव असलेला फुल-स्टॅक डेव्हलपर आहे."
    },
    ar: {
        selectLanguage: "اختر اللغة",
        country: "الدولة",
        mobileNumber: "رقم الجوال",
        submit: "إرسال",
        mobileRequired: "رقم الجوال مطلوب",
        invalidMobile: "رقم الجوال غير صالح",
        developerInfo: "اسمي كامران خان، وأنا مطور متكامل مع أكثر من 5 سنوات من الخبرة."
    },
};

// Create Translation Context
const TranslationContext = createContext();

// Hook to use translations
export const useTranslation = () => {
    const { language, changeLanguage } = useContext(TranslationContext);
    const t = (key) => translations[language][key] || key; // Function to get translation
    return { t, changeLanguage };
};

// Translation Provider
export const TranslationProvider = ({ children }) => {
    const [language, setLanguage] = useState("en");

    const changeLanguage = (lang) => {
        setLanguage(lang);
    };

    return (
        <TranslationContext.Provider value={{ language, changeLanguage }}>
            {children}
        </TranslationContext.Provider>
    );
};
